export const categories = [
    { slug: 'dinos-chidos', label: 'Dinos Chidos', image: '/img/categories/dinos-chidos.png' },
    { slug: 'espacio-chido', label: 'Espacio Chido', image: '/img/categories/espacio-chido.png' },
    { slug: 'animal-friends', label: 'Animal Friends', image: '/img/categories/animal-friends.png' },
    { slug: 'deportes-chidos', label: 'Deportes Chidos', image: '/img/categories/deportes-chidos.png' },
    { slug: 'arcoiris-y-magia', label: 'Arcoíris y Magia', image: '/img/categories/arcoiris-y-magia.png' },
    { slug: 'game-zone', label: 'Game Zone', image: '/img/categories/game-zone.png' },
    // Categoría "spotlight" que se muestra como rail único en el home
    // (por ahora dinos-chidos, cámbialo aquí si quieres destacar otra)
]

export const homeSpotlightSlug = 'dinos-chidos'

export function getCategoryBySlug(slug) {
    return categories.find((c) => c.slug === slug)
}